<template>
    <el-dialog width="60%"
               v-dialog-drag
               title="功能点管理"
               :before-close="handleClickCancel"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               :visible.sync="pointVisible">
        <div class="point" v-loading="loading">
            <template>
                <div class="btn">
                    <el-button size="small" type="danger" @click="delBatchPoint">批量删除</el-button>
                    <el-button size="small" type="primary" @click="addPoint">添加功能</el-button>
                </div>
                <el-table ref="userList" border :data="tableData" @selection-change="handleSelectionChange"
                          height="560px">
                    <el-table-column width="50" type="selection" align="center"></el-table-column>
                    <el-table-column label="名称" align="center" prop="title" show-overflow-tooltip
                                     width="120px"></el-table-column>
                    <el-table-column label="链接" align="center" prop="route" show-overflow-tooltip></el-table-column>
                    <el-table-column label="角色权限是否展示" width="150" align="center">
                        <tempalte slot-scope="{row}">
                            <el-switch v-model="row.role_show"
                                       active-text="是"
                                       inactive-text="否"
                                       :active-value="1"
                                       :inactive-value="0"
                                       @change="handleTreeNodeEdit($event,row)">
                            </el-switch>
                        </tempalte>
                    </el-table-column>
                    <el-table-column label="是否有范围数据权限" width="150" align="center">
                        <tempalte slot-scope="{row}">
                            <el-switch v-model="row.role_range"
                                       active-text="是"
                                       inactive-text="否"
                                       :active-value="1"
                                       :inactive-value="0"
                                       @change="handleTreeNodeEdit($event,row)">
                            </el-switch>
                        </tempalte>
                    </el-table-column>
                    <el-table-column label="是否为公共节点" width="150" align="center">
                        <tempalte slot-scope="{row}">
                            <el-switch v-model="row.is_public"
                                       active-text="是"
                                       inactive-text="否"
                                       :active-value="1"
                                       :inactive-value="0"
                                       @change="handleTreeNodeEdit($event,row)">
                            </el-switch>
                        </tempalte>
                    </el-table-column>
                  <el-table-column label="排序" align="center" prop="sort" width="110px">
                    <template slot-scope="{row}">
                      <div class="inputNumber">
                        <el-input-number v-model="row.sort"  :min="0" :controls="false" size="small" @change="handleTreeNodeEditSort($event,row)"></el-input-number>
                      </div>

                    </template>
                  </el-table-column>
                    <el-table-column label="操作" align="center" prop="id" width="110px">
                        <template slot-scope="{row}">
                            <el-button type="text" @click="editPoint(row)">编辑</el-button>
                            <el-button type="text" @click="delPoint(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>

        <template>
            <el-dialog :title="pointId ? '编辑功能点' : '新增功能点'"
                       :visible.sync="pointTplVisible"
                       width="35%"
                       append-to-body
                       :close-on-click-modal="false">
                <PointTpl :pointTplVisible.sync="pointTplVisible"
                          @success="getPointList"
                          :pointPid="menuId"
                          :pointId="pointId"
                          :menu_pid_path="menu_pid_path"
                          v-if="pointTplVisible"/>
            </el-dialog>
        </template>
    </el-dialog>
</template>
<script>
    import {MenuFuncPointBatchDel, MenuFuncPointDel, ReqMenuList, treeNodeEdit,treeNodeEditSort} from '@/api'
    import PointTpl from './pointTpl.vue'

    export default {
        name: 'Point',
        components: {
            PointTpl
        },
        props: {
            pointVisible: {
                type: Boolean,
                default: false,
            },
            menuId: {
                type: Number,
                default: 0,
            },
            menu_pid_path: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                loading: false,
                BtnDisabled: false,
                multipleSelection: [],
                tableData: [],
                pointTplVisible: false, //新增编辑功能点弹窗
                pointId: 0, //编辑功能点的id
            }
        },
        created() {
            if (this.menuId) {
                this.getPointList()
            }
        },
        mounted() {

        },
        methods: {
            // 添加功能点
            addPoint() {
                this.pointId = 0
                this.pointTplVisible = true
            },

            // 编辑功能点
            editPoint(row) {
                this.pointId = row.id
                this.pointTplVisible = true
            },

            // 删除功能点
            delPoint(row) {
                this.$confirm('确定删除该功能点吗', '提示', {
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    type: 'error'
                }).then(() => {
                    MenuFuncPointDel({
                        id: row.id
                    }).then(() => {
                        this.$message.success('删除成功')
                        this.getPointList()
                    })
                }).catch(() => {
                    return false
                })
            },

            // 批量删除功能点
            delBatchPoint() {
                if (this.multipleSelection.length === 0) {
                    this.$message.error('请至少选择一个')
                    return false
                }
                let ids = this.multipleSelection.map((item, key) => {
                    return item.id
                }).join()

                this.$confirm('确定删除该功能点吗', '提示', {
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    type: 'error'
                }).then(() => {
                    MenuFuncPointBatchDel({
                        ids: ids
                    }).then(() => {
                        this.$message.success('删除成功')
                        this.getPointList()
                    })
                }).catch(() => {
                    return false
                })
            },

            getPointList() {
                this.loading = true
                ReqMenuList({
                    treenode_id: this.menuId
                }).then(res => {
                    this.tableData = res.data
                    this.pointId = 0
                    this.loading = false
                })
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            handleTreeNodeEdit(val, row) {
                treeNodeEdit({
                    treenode_id: row.id,
                    role_show: row.role_show,
                    role_range: row.role_range,
                    is_public: row.is_public,
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('设置成功')
                    }
                })
            },

          handleTreeNodeEditSort(val, row) {
            treeNodeEditSort({
              treenode_id: row.id,
              sort: row.sort,
            }).then(res => {
              if (res.code === 200) {
                this.$message.success('设置成功')
                this.getPointList()
              }
            })
          },

            //取消事件
            handleClickCancel() {
                //关闭对话框
                this.$emit('update:pointVisible', false)
            },
        },
    }
</script>
<style lang="scss" scoped>
  .btn {
    margin-bottom: 10px;
    text-align: right
  }
  .inputNumber .el-input-number--small{
    width: 90px;
  }
</style>
